// extracted by mini-css-extract-plugin
export default {"container":"rE-z","title":"sE-z","link":"tE-z"};